export interface DigitalDelivery {
  id: string
  name: string
  url: string
  type: string
  size?: string
}

export const EmitterKeys = {
  SELECTED_MEDIA_FILE: 'selected-media-file',
  OPEN_MEDIA_LIBRARY: 'media-library-open',
}

export enum AltTypes {
  LOCATION = 'location',
  AGENCY = 'agency',
}

export const MediaEvents = {
  SELECTED_MEDIA: 'selected-media',
}

export enum MediaCenterType {
  IMAGE = 'image',
  VIDEO = 'video',
  DOCUMENT = 'application',
  AUDIO = 'audio',
}

export const ContentTypes = {
  IMAGE: MediaCenterType.IMAGE,
  VIDEO: MediaCenterType.VIDEO,
  DOCUMENT: MediaCenterType.DOCUMENT,
  AUDIO: MediaCenterType.AUDIO,
}
